// extracted by mini-css-extract-plugin
module.exports = {"heading":"style__heading___1W7n8 reset__reset___2e25U","heading--h1":"style__heading--h1___3kXr4"};